import React from 'react';
import background from '../../assets/lionfish.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoLionfish extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="INVASIVE PREDATOR"
        description="Lionfish"
        paragraph="Lionfish, which are native to the Indo-Pacific, were first detected along Florida coasts in the mid-1980s. The species is harming native coral reef ecosystems in the Atlantic, Gulf of Mexico, and Caribbean (NOAA)."
        background={background}
     />
  
  );
 }
}   

export default InfoLionfish;